import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import "./view-my-bookings.css";

function ViewMyBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        try {
          const db = getFirestore();
          const bookingsRef = collection(db, "bookings");
          const q = query(bookingsRef, where("email", "==", user.email));
          const querySnapshot = await getDocs(q);

          const userBookings = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
          }));

          setBookings(userBookings);
        } catch (error) {
          console.error("Error fetching bookings:", error);
        }
      }
      setLoading(false);
    };

    fetchBookings();
  }, []);

  if (loading) {
    return <p className="loading-text">Loading your bookings...</p>;
  }

  if (bookings.length === 0) {
    return <p className="no-bookings">No bookings found for your account.</p>;
  }

  return (
    <>
                <section className="hero">
              <div className="hero-image">
                  <img src="/logo192.png" alt="conference" />
                </div>
                <div className="hero-content">
          <h1>Chavo Tours & Taxi</h1>
          <p>Welcome to Chavo Tours, your premier choice for taxi and tour services in Sri Lanka. 
            We offer reliable, safe, and affordable transportation for both tourists and locals. 
            Book your ride today for the best travel experience.</p>
                </div>
            </section>
    

    <div className="bookings-container">
      <h1 className="page-title">My Bookings</h1>
      <div className="bookings-grid">
        {bookings.map((booking) => (
          <div className="booking-card" key={booking.id}>
            <div className="booking-header">
              <h2>{booking.pickup} → {booking.dropoff}</h2>
              <span className="transfer-type">{booking.transferType}</span>
            </div>
            <div className="booking-details">
              <p><strong>Pickup Date:</strong> {booking.pickupDate}</p>
              <p><strong>Pickup Time:</strong> {booking.pickupTime}</p>
              <p><strong>Vehicle:</strong> {booking.vehicleType}</p>
              <p><strong>Adults:</strong> {booking.adultsCount}</p>
              <p><strong>Children:</strong> {booking.childrenCount}</p>
              <p><strong>Name:</strong> {booking.firstName} {booking.lastName}</p>
              <p><strong>Email:</strong> {booking.email}</p>
              <p><strong>Phone:</strong> {booking.phone}</p>
              {booking.comment && (
                <p><strong>Comment:</strong> {booking.comment}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
        </>
  );
}

export default ViewMyBookings;
